import { PAYPAL_CANCELLED, STRIPE_CANCELLED, STRIPE_NEED_ACTION } from '../../constants/subscriptions';

export const isCancelled = attentionNeeded => [STRIPE_CANCELLED, PAYPAL_CANCELLED].includes(attentionNeeded);

export const needsAction = attentionNeed => [STRIPE_NEED_ACTION].includes(attentionNeed);
